import React from 'react';
import { bigHoverActionContainer } from './BigHoverAction.scss';

export default function BigHoverActionPlaceholder(): React.JSX.Element {
    return <div className={bigHoverActionContainer}></div>;
}
